import { Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoverArtContainer } from './CoverArtContainer';

type PropsType = {
  releaseId: string;
};

const CoverArtSection = ({ releaseId }: PropsType) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        alignItems: 'flex-start',
        [theme.breakpoints.down('md')]: { alignItems: 'center' },
        gap: theme.spacing(2),
      }}
    >
      <Stack sx={{ alignSelf: 'flex-start', gap: theme.spacing(0.5) }}>
        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
          {t('distribution:details:coverArt:title')}
        </Typography>
        <Typography sx={{ fontSize: 16, color: theme.palette.grey[400] }}>
          {t('distribution:details:coverArt:limits')}
        </Typography>
      </Stack>
      <CoverArtContainer releaseId={releaseId} />
    </Stack>
  );
};

export default CoverArtSection;
